import {createContext, PropsWithChildren, useEffect, useState} from "react";

import {
  closeZendeskMessengerWidget,
  onZendeskMessengerEvent,
  openZendeskMessengerWidget,
} from "@/lib/integrations/zendesk.ts";

interface ZendeskMessengerContext {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

const DEFAULT_VALUE: ZendeskMessengerContext = {
  isOpen: false,
  open: () => {},
  close: () => {},
};

export const ZendeskMessengerContext = createContext<ZendeskMessengerContext>(DEFAULT_VALUE);

export const ZendeskMessengerProvider = ({children}: PropsWithChildren) => {
  const [isOpen, setIsOpen] = useState(false);

  // In embedded mode the widget's own close control only emits an event and hides itself,
  // so mirror it here or our host container would stay on screen.
  useEffect(() => onZendeskMessengerEvent("close", () => setIsOpen(false)), []);

  const open = () => {
    setIsOpen(true);
    openZendeskMessengerWidget();
  };
  const close = () => {
    setIsOpen(false);
    closeZendeskMessengerWidget();
  };

  return <ZendeskMessengerContext.Provider value={{isOpen, open, close}}>{children}</ZendeskMessengerContext.Provider>;
};
